/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestEndingSoonNotificationAction } from './FanRemixContestEndingSoonNotificationAction';
import {
    FanRemixContestEndingSoonNotificationActionFromJSON,
    FanRemixContestEndingSoonNotificationActionFromJSONTyped,
    FanRemixContestEndingSoonNotificationActionToJSON,
} from './FanRemixContestEndingSoonNotificationAction';

/**
 * 
 * @export
 * @interface FanRemixContestEndingSoonNotification
 */
export interface FanRemixContestEndingSoonNotification {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestEndingSoonNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof FanRemixContestEndingSoonNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestEndingSoonNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<FanRemixContestEndingSoonNotificationAction>}
     * @memberof FanRemixContestEndingSoonNotification
     */
    actions: Array<FanRemixContestEndingSoonNotificationAction>;
}

/**
 * Check if a given object implements the FanRemixContestEndingSoonNotification interface.
 */
export function instanceOfFanRemixContestEndingSoonNotification(value: object): value is FanRemixContestEndingSoonNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function FanRemixContestEndingSoonNotificationFromJSON(json: any): FanRemixContestEndingSoonNotification {
    return FanRemixContestEndingSoonNotificationFromJSONTyped(json, false);
}

export function FanRemixContestEndingSoonNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestEndingSoonNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(FanRemixContestEndingSoonNotificationActionFromJSON)),
    };
}

export function FanRemixContestEndingSoonNotificationToJSON(value?: FanRemixContestEndingSoonNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(FanRemixContestEndingSoonNotificationActionToJSON)),
    };
}

